import { TranslationKeys } from '../../TranlsationKeys';

export const districtDescriptions: Record<
  number,
  { title: TranslationKeys; text: TranslationKeys[] }
> = {
  124: {
    title: 'ClubListContainer.Description.District.BarcelonaCostaBrava.Title',
    text: [
      'ClubListContainer.Description.District.BarcelonaCostaBrava.p1',
      'ClubListContainer.Description.District.BarcelonaCostaBrava.p2',
    ],
  },
  125: {
    title: 'ClubListContainer.Description.District.CostadelSol.Title',
    text: [
      'ClubListContainer.Description.District.CostadelSol.p1',
      'ClubListContainer.Description.District.CostadelSol.p2',
      'ClubListContainer.Description.District.CostadelSol.p3',
      'ClubListContainer.Description.District.CostadelSol.p4',
    ],
  },
  126: {
    title: 'ClubListContainer.Description.District.CostaBlanca.Title',
    text: [
      'ClubListContainer.Description.District.CostaBlanca.p1',
      'ClubListContainer.Description.District.CostaBlanca.p2',
      'ClubListContainer.Description.District.CostaBlanca.p3',
    ],
  },
};
